import React from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n from './i18n';
import Header from './components/Header';
import ProjectCard from './components/ProjectCard';
import { projects } from './data/projects';
import './App.css';

function App() {
  const { t } = useTranslation();

  return (
    <I18nextProvider i18n={i18n}>
      <div className="App">
        <Header />
        
        <main className="container">
          <section className="intro">
            <h2>{t('projects.title')}</h2>
            <p>{t('projects.subtitle')}</p>
          </section>
          
          <div className="projects-grid">
            {projects.map(project => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        </main>
        
        <footer className="footer">
          <div className="container">
            <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
          </div>
        </footer>
      </div>
    </I18nextProvider>
  );
}

export default App;